/**
 * Generates a mini SVG preview of a template's nodes and edges.
 */
export function TemplateMiniPreview({ nodes, edges, width = 120, height = 70 }) {
  if (!nodes || nodes.length === 0) return null;

  // Calculate bounds
  const nodeW = 80;
  const nodeH = 30;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  nodes.forEach(n => {
    const px = n.position?.x || 0;
    const py = n.position?.y || 0;
    if (px < minX) minX = px;
    if (py < minY) minY = py;
    if (px + nodeW > maxX) maxX = px + nodeW;
    if (py + nodeH > maxY) maxY = py + nodeH;
  });

  const pad = 10;
  const srcW = maxX - minX + pad * 2;
  const srcH = maxY - minY + pad * 2;

  // Scale to fit
  const scale = Math.min(width / srcW, height / srcH);
  const offsetX = (width - srcW * scale) / 2 - minX * scale + pad * scale;
  const offsetY = (height - srcH * scale) / 2 - minY * scale + pad * scale;

  // Node position map for edges
  const nodeMap = {};
  nodes.forEach(n => {
    nodeMap[n.id] = {
      cx: (n.position?.x || 0) * scale + offsetX + (nodeW * scale) / 2,
      cy: (n.position?.y || 0) * scale + offsetY + (nodeH * scale) / 2,
    };
  });

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="rounded-md bg-gray-50/80">
      {/* Edges */}
      {(edges || []).map(e => {
        const src = nodeMap[e.source];
        const tgt = nodeMap[e.target];
        if (!src || !tgt) return null;
        return (
          <line
            key={e.id}
            x1={src.cx}
            y1={src.cy}
            x2={tgt.cx}
            y2={tgt.cy}
            stroke="#C7D2FE"
            strokeWidth="1"
            strokeOpacity="0.7"
          />
        );
      })}
      {/* Nodes */}
      {nodes.map(n => {
        const x = (n.position?.x || 0) * scale + offsetX;
        const y = (n.position?.y || 0) * scale + offsetY;
        const w = Math.max(nodeW * scale, 8);
        const h = Math.max(nodeH * scale, 5);
        const color = n.data?.color || "#6366F1";
        return (
          <g key={n.id}>
            <rect
              x={x}
              y={y}
              width={w}
              height={h}
              rx={3}
              fill="white"
              stroke={color}
              strokeWidth="1"
              strokeOpacity="0.6"
            />
            <rect
              x={x}
              y={y}
              width={w}
              height={2}
              rx={1}
              fill={color}
              fillOpacity="0.7"
            />
          </g>
        );
      })}
    </svg>
  );
}
